/* Funtastic — fotos2: auto-enquadramento das fotos de produto + controlos da galeria por baixo da foto no telemóvel.
   Deteta a caixa do produto (píxeis diferentes do fundo claro/uniforme dos cantos) numa canvas pequena e aplica
   translate+scale para o produto ocupar ~88% da largura ou ~85% da altura do palco (zoom máx. 1.8x).
   Se a deteção falhar (canvas bloqueada, fundo escuro/não uniforme, foto de ambiente), não faz nada (contain normal). */
(function(){
  if (window.FSFit) return;
  var SEL = '.fs-stage__slide img,.fs-card__stage img,.at-car__stage img,.fs-cl__img img,.fs-x__img img,.fs-pd__img img,.fs-line__img img';
  var MOB = window.matchMedia('(max-width:749px)');
  var cache = {}, SK = 'fsfit1';
  try { cache = JSON.parse(sessionStorage.getItem(SK) || '{}') || {}; } catch (e) { cache = {}; }
  function save(){ try { sessionStorage.setItem(SK, JSON.stringify(cache)); } catch (e) {} }
  function key(src){ try { var u = new URL(src, location.href); return u.pathname.replace(/^.*\/(files|products)\//, '$1/'); } catch (e) { return src; } }

  /* ---------- deteção ---------- */
  function analyse(src){
    var M = 200, w = src.naturalWidth, h = src.naturalHeight;
    if (!w || !h) return null;
    var s = Math.min(1, M / Math.max(w, h)), cw = Math.max(1, Math.round(w * s)), ch = Math.max(1, Math.round(h * s));
    var c = document.createElement('canvas'); c.width = cw; c.height = ch;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(src, 0, 0, cw, ch);
    var d = x.getImageData(0, 0, cw, ch).data; /* lança se a canvas estiver "tainted" */
    function px(i, j){ var k = (j * cw + i) * 4; return [d[k], d[k+1], d[k+2], d[k+3]]; }
    /* fundo = média de cada canto (4x4); os cantos têm de ser claros e parecidos */
    var corners = [[0,0],[cw-4,0],[0,ch-4],[cw-4,ch-4]], cs = [];
    corners.forEach(function(p){
      var r=0,g=0,b=0,a=0,n=0;
      for (var j=0;j<4;j++) for (var i=0;i<4;i++){ var q = px(Math.max(0,p[0]+i), Math.max(0,p[1]+j)); r+=q[0];g+=q[1];b+=q[2];a+=q[3];n++; }
      cs.push([r/n,g/n,b/n,a/n]);
    });
    var transp = cs.every(function(q){ return q[3] < 20; });
    var bg = [0,1,2].map(function(k){ return (cs[0][k]+cs[1][k]+cs[2][k]+cs[3][k]) / 4; });
    if (!transp){
      for (var t=0;t<4;t++){
        if (cs[t][3] < 200) return null;
        if (Math.min(cs[t][0], cs[t][1], cs[t][2]) < 200) return null; /* fundo não é claro */
        for (var k=0;k<3;k++) if (Math.abs(cs[t][k] - bg[k]) > 22) return null; /* fundo não uniforme */
      }
    }
    var T = 30, colN = new Array(cw).fill(0), rowN = new Array(ch).fill(0), fg = 0;
    for (var j=0;j<ch;j++) for (var i=0;i<cw;i++){
      var k = (j*cw+i)*4, on;
      if (d[k+3] < 128) on = false;
      else if (transp) on = true;
      else on = Math.max(Math.abs(d[k]-bg[0]), Math.abs(d[k+1]-bg[1]), Math.abs(d[k+2]-bg[2])) > T;
      if (on){ colN[i]++; rowN[j]++; fg++; }
    }
    var mc = Math.max(2, ch * .012), mr = Math.max(2, cw * .012);
    var x0=0,x1=cw-1,y0=0,y1=ch-1;
    while (x0 < cw && colN[x0] < mc) x0++;
    while (x1 > x0 && colN[x1] < mc) x1--;
    while (y0 < ch && rowN[y0] < mr) y0++;
    while (y1 > y0 && rowN[y1] < mr) y1--;
    if (x0 >= x1 || y0 >= y1) return null;
    var bw = x1 - x0 + 1, bh = y1 - y0 + 1, area = bw * bh / (cw * ch);
    if (area < .03 || area > .97) return null;
    /* fora da caixa tem de ser quase tudo fundo (senão é cenário/ambiente) */
    var out = cw * ch - bw * bh, fgIn = 0;
    for (var jj=y0;jj<=y1;jj++){ for (var ii=x0;ii<=x1;ii++){ var kk=(jj*cw+ii)*4; if (transp ? d[kk+3]>=128 : (d[kk+3]>=128 && Math.max(Math.abs(d[kk]-bg[0]),Math.abs(d[kk+1]-bg[1]),Math.abs(d[kk+2]-bg[2]))>T)) fgIn++; } }
    if (out > 0 && (fg - fgIn) / out > .04) return null;
    /* margem de segurança de 2% (contornos claros, ex.: carros brancos) */
    var px2 = .02 * cw, py2 = .02 * ch;
    return [Math.max(0,(x0-px2)/cw), Math.max(0,(y0-py2)/ch), Math.min(1,(x1+1+px2)/cw), Math.min(1,(y1+1+py2)/ch)].map(function(v){ return Math.round(v*1e4)/1e4; });
  }

  /* ---------- aplicar ---------- */
  function apply(img){
    var b = img._fsb, box = img.parentElement;
    if (!b || !box) return;
    if (img.offsetParent !== box){ clear(img); return; }
    var SW = box.clientWidth, SH = box.clientHeight, iw = img.clientWidth, ih = img.clientHeight;
    if (!SW || !SH || !iw || !ih) return;
    var cs = getComputedStyle(img), pl = parseFloat(cs.paddingLeft)||0, pr = parseFloat(cs.paddingRight)||0, pt = parseFloat(cs.paddingTop)||0, pb = parseFloat(cs.paddingBottom)||0;
    var W = iw - pl - pr, H = ih - pt - pb, nw = img.naturalWidth, nh = img.naturalHeight;
    if (W <= 0 || H <= 0 || !nw || !nh) return;
    var s0 = Math.min(W / nw, H / nh), ox = img.offsetLeft + pl + (W - nw*s0)/2, oy = img.offsetTop + pt + (H - nh*s0)/2;
    var bx0 = ox + b[0]*nw*s0, by0 = oy + b[1]*nh*s0, bw = (b[2]-b[0])*nw*s0, bh = (b[3]-b[1])*nh*s0;
    /* área útil: o palco todo; na galeria em desktop, sem a faixa das setas/contador em baixo */
    /* cores-card 17/10: nos cartões, 6% em baixo livres para a pílula das cores (canto inferior direito) */
    var R = (img.closest('.fs-stage__slide') && !MOB.matches) ? 62 : (img.closest('.fs-card__stage,.at-car__stage') ? Math.round(SH * .06) : 0), AH = SH - R;
    var k = Math.min(.88 * SW / bw, .85 * AH / bh, 1.8);
    k = Math.max(k, Math.min(1, .9 * SW / bw, .9 * AH / bh)); /* não encolher sem necessidade */
    var tx = SW/2 - (bx0 + bw/2) * k, ty = AH/2 - (by0 + bh/2) * k;
    /* translate/scale relativos à origem 0 0 do próprio img */
    var ix = img.offsetLeft, iy = img.offsetTop;
    var dx = tx + ix*k - ix, dy = ty + iy*k - iy;
    if (Math.abs(k - 1) < .02 && Math.abs(dx) < 2 && Math.abs(dy) < 2){ clear(img); return; }
    img.style.setProperty('--fs-fx', dx.toFixed(1) + 'px');
    img.style.setProperty('--fs-fy', dy.toFixed(1) + 'px');
    img.style.setProperty('--fs-fk', k.toFixed(4));
    img.classList.add('fs-fit');
  }
  function clear(img){ img.classList.remove('fs-fit'); }
  function reveal(img){ img.classList.remove('fs-fit-wait'); }

  function measure(img){
    if (img._fsd) return;
    var src = img.currentSrc || img.src; if (!src) return;
    var kk = key(src);
    if (kk in cache){ img._fsd = 1; img._fsb = cache[kk]; if (img._fsb) apply(img); reveal(img); return; }
    if (!img.complete || !img.naturalWidth) return;
    img._fsd = 1;
    var same = false; try { same = new URL(src, location.href).origin === location.origin; } catch (e) {}
    function done(b){ cache[kk] = b; save(); img._fsb = b; if (b) apply(img); reveal(img); }
    if (same){ var r = null; try { r = analyse(img); } catch (e) { r = null; } done(r); return; }
    /* outra origem (cdn.shopify.com): cópia pequena com CORS; a imagem visível não é tocada */
    var u; try { u = new URL(src, location.href); u.searchParams.set('width', '200'); } catch (e) { done(null); return; }
    var t = new Image(); t.crossOrigin = 'anonymous'; t.decoding = 'async';
    t.onload = function(){ var r = null; try { r = analyse(t); } catch (e) { r = null; } done(r); };
    t.onerror = function(){ done(null); };
    t.src = u.href;
  }

  function hook(img){
    if (img._fsh) return; img._fsh = 1;
    if (img.closest('.fs-thumbs')) return;
    var kk = key(img.currentSrc || img.src || '');
    if (img.complete && img.naturalWidth && !(kk in cache)) img.classList.add('fs-fit-tr'); /* já visível: transição curta */
    else if (!(img.complete && img.naturalWidth) && !(kk in cache && !cache[kk])){
      img.classList.add('fs-fit-wait');
      setTimeout(function(){ reveal(img); }, 1500); /* nunca fica escondida */
    }
    img.addEventListener('load', function(){ img._fsd = 0; measure(img); });
    img.addEventListener('error', function(){ reveal(img); });
    if (img.closest('.fs-stage__slide')) { measure(img); return; }
    io ? io.observe(img) : measure(img);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ io.unobserve(e.target); measure(e.target); } });
  }, { rootMargin: '300px 0px' }) : null;

  /* ---------- telemóvel: setas + contador/pontos por baixo da foto ---------- */
  function bar(gal){
    var g = gal.querySelector('[data-fs-gallery]'); if (!g || gal.querySelector('.fs-gbar')) return;
    var prev = g.querySelector('[data-prev]'), next = g.querySelector('[data-next]'), count = g.querySelector('.fs-stage__count');
    var n = g.querySelectorAll('.fs-stage__slide').length; if (n < 2) return;
    var dots = gal.querySelector('.fs-dots');
    var es = (document.documentElement.lang || '').indexOf('es') === 0;
    var b = document.createElement('div'); b.className = 'fs-gbar';
    var chev = function(d){ return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
    b.innerHTML = '<button type="button" class="fs-gbar__b" data-d="-1" aria-label="' + (es ? 'Imagen anterior' : 'Imagem anterior') + '">' + chev(-1) + '</button><div class="fs-gbar__c"></div><button type="button" class="fs-gbar__b" data-d="1" aria-label="' + (es ? 'Imagen siguiente' : 'Imagem seguinte') + '">' + chev(1) + '</button>';
    var mid = b.querySelector('.fs-gbar__c');
    if (dots && n <= 8 && dots.children.length >= n){ mid.appendChild(dots); b.classList.add('fs-gbar--dots'); }
    else if (count){
      var sp = document.createElement('span'); sp.className = 'fs-gbar__n fs-num'; sp.setAttribute('aria-live', 'polite');
      var sync = function(){ sp.textContent = count.textContent; }; sync();
      new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
      mid.appendChild(sp);
      if (dots) dots.classList.add('fs-dots--off');
    }
    var after = dots && !b.contains(dots) ? dots : null;
    (after || g).parentNode.insertBefore(b, (after || g).nextSibling);
    b.addEventListener('click', function(e){
      var t = e.target.closest('.fs-gbar__b'); if (!t) return;
      var o = t.getAttribute('data-d') < 0 ? prev : next;
      if (o) o.click();
      else { var tr = g.querySelector('.fs-stage__slides'); if (tr) tr.scrollBy({ left: (t.getAttribute('data-d') < 0 ? -1 : 1) * tr.clientWidth, behavior: 'smooth' }); }
    });
  }

  var to;
  function scan(){
    document.querySelectorAll('.fs-model__gal').forEach(bar);
    document.querySelectorAll(SEL).forEach(hook);
  }
  function reapply(){ document.querySelectorAll(SEL).forEach(function(i){ if (i._fsb) apply(i); }); }
  function start(){
    scan();
    new MutationObserver(function(){ clearTimeout(to); to = setTimeout(scan, 60); }).observe(document.body, { childList: true, subtree: true });
    var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(reapply, 120); });
    if (MOB.addEventListener) MOB.addEventListener('change', reapply);
    window.addEventListener('load', reapply);
  }
  window.FSFit = { scan: scan, analyse: analyse, apply: apply, cache: cache };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
